import {
  Box,
  Button,
  Center,
  Flex,
  Image,
  Text, useDisclosure,
  VStack,
  Link as ChakraLink, Tooltip,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Portal,
} from "@chakra-ui/react";
import NodeTree from "../OutlineNodeTree/NodeTree.tsx";
import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { pxToRem } from "../../utils/editor.ts";
import useOutlineStore from "../../stores/modules/outline.ts";
import { PaperOutline } from "../../types/Writer/OutlineNode.ts";
import { DoenbaStructure } from "./Structure/DoenbaStructure.tsx";
import useEditorStore from "../../stores/modules/editor.ts";
import { useRecoilState } from "recoil";
import { leftDrawerOpenStatus } from "../../atoms/rootAtom";
import { DoenbaExportModal } from "./DoenbaExportModal.tsx";

/**
 * left outline overview
 */
interface LeftOutlineProps {
  popOpen: boolean
  setPopOpen: (popOpen: boolean) => void
  paperId: string
  setPaperId: (paperId: string) => void
  leftBarWidth: string
  updateOutlineStructure: (outline: PaperOutline) => void
  setIsExport: (isExport: boolean) => void
  paperName?: string
}
export const LeftOutline: React.FC<LeftOutlineProps> = (
  {
    popOpen,
    setPopOpen,
    setPaperId,
    setIsExport,
    leftBarWidth,
    updateOutlineStructure,
    paperName,
    paperId,
  }
) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { outline, setOutline, setNodeList, setNextId, setOutlineIsChange, setCurrentSectionIndex, setToolPopOpen } = useOutlineStore();
  // const [referencePanelOpenStatus, setReferencePanelOpenStatus] = useState<boolean>(false);
  const [referencePanelOpenStatus] = useState<boolean>(false);
  const { isOpen: isStructureOpen, onOpen: openStructure, onClose: closeStructure } = useDisclosure();
  const { isOpen: isDoenbaExportOpen, onOpen: onDoenbaExportOpen, onClose: onDoenbaExportClose } = useDisclosure();
  const [structureType, setStructureType] = useState<'import' | 'refer' | 'doenba'>('import')
  const { setFocusEditor } = useEditorStore();
  const [writingArea, setWritingArea] = useState<string>('');
  const [subject] = useState([
    {
      label: 'Biology',
      value: 'Biology'
    },
    {
      label: 'Chemistry',
      value: 'Chemistry'
    },
    {
      label: 'Computer Science',
      value: 'Computer Science'
    },
    {
      label: 'Mathematics',
      value: 'Mathematics'
    },
    {
      label: 'Physics',
      value: 'Physics'
    },
    {
      label: 'Math Modeling',
      value: 'Math Modeling'
    }
  ])
  const [, setDrawerOpenStatus] = useRecoilState(leftDrawerOpenStatus);

 
  const popupRef = useRef<HTMLDivElement>(null);
  // 添加全局点击事件监听器
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (popOpen && popupRef.current && !popupRef.current.contains(event.target as Node)) {
        setPopOpen(false);
      }
    };
    
    document.addEventListener('mousedown', handleClickOutside);
    
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [popOpen, setPopOpen]);

  return (
    <React.Fragment>
      <Flex
        h={"100%"}
        flexDir={"column"}
        w={leftBarWidth}
        justifyContent={"space-between"}
        boxShadow={"md"}
        position={"relative"}
        transition={"all 0.5s ease"}
        bgColor={"#FBFCFF"}
        overflow={'hidden'}
        borderRight={'2px solid #D3D7E2'}
        onClick={() => {
          setToolPopOpen(false)
          setPopOpen(false)
        }}
      >
        <Flex flexDir={"column"}>
          <Center
            p={10}
            onClick={() => {
              setOutline(null)
              setNodeList([])
              setNextId(0)
              setToolPopOpen(false)
              setCurrentSectionIndex(0)
              setOutlineIsChange(false)
              setPaperId('')
              navigate("/edit")
            }}
            cursor={"pointer"}
          >
            <Image
              w={pxToRem(144)}
              h={pxToRem(40)}
              objectFit="contain"
              src={"/static/doenba-logo-blue.png"}
            />
          </Center>
          {/** refer article */}
          <Flex
            flexDir={"column"}
            px={2}
            py={2}
            alignItems={'center'}
          >
            {/* <Tooltip hasArrow placement={'right'}
                     borderRadius={pxToRem(6)}
                     padding={4} bg={'#FFF'} color={'#333'} label={
              <Text fontSize={'1rem'} fontFamily={'Lato'}>Upload a (.tex, .txt, or docx) file to edit, or start from scratch.</Text>
            } aria-label='import'>
              <Button
                color={'#FFF'}
                bg={'#333'}
                width={pxToRem(140)}
                borderRadius={pxToRem(6)}
                _hover={{ bg: '#333' }}
                onClick={() => {
                  setStructureType('import')
                  setFocusEditor(false)
                  openStructure()
                }}
                leftIcon={
                  <Image
                    borderRadius={pxToRem(8)}
                    padding={'2px'}
                    mt={1}
                    w={pxToRem(20)} src={'/static/editor/upload.svg'} />
                }>{t('import')}</Button>
            </Tooltip> */}
            <Button
              w={"full"}
              mt={2}
              border={'1px solid #3898FF44'}
              bgColor={"transparent"}
              cursor={'pointer'}
              _hover={{ color: "#ADD2FC", bg: '#3898FF33' }}
              // leftIcon={
              //   <Image
              //     w={pxToRem(20)}
              //     objectFit="contain"
              //     src="/static/editor/structure.png"
              //   />
              // }
              // onClick={() =>
              //   setReferencePanelOpenStatus(!referencePanelOpenStatus)
              // }
              onClick={(e) => {
                e.stopPropagation()
                setStructureType('doenba')
                setPopOpen(!popOpen)
              }}
            >
              <Tooltip hasArrow placement={'right'}
                       borderRadius={pxToRem(6)}
                       padding={4} bg={'#FFF'} color={'#333'} label={
                <Text margin={0} fontSize={'1rem'} fontFamily={'Lato'}>{t('outline-tooltip')}</Text>
              } aria-label='Outline'>
                <Text m={1} color={"#333"} fontSize={pxToRem(18)}>
                    { t('outline-text') }
                </Text>
              </Tooltip>
            </Button>
            {referencePanelOpenStatus && (
              <Box
                w={'full'}
                transition={"all 0.5s ease"}
              >
                <Flex flexDir={"column"} justifyContent={"space-between"}>
                <Button
                  w={"full"}
                  mt={2}
                  border={'1px solid #3898FF44'}
                  bgColor={"transparent"}
                  cursor={'pointer'}
                  _hover={{ color: "#ADD2FC", bg: '#3898FF33' }}
                  onClick={(e) => {
                    e.stopPropagation()
                    setStructureType('doenba')
                    setPopOpen(!popOpen)
                  }}
                >
                  <Tooltip hasArrow placement={'right'}
                           borderRadius={pxToRem(6)}
                           padding={4} bg={'#FFF'} color={'#333'} label={
                    <Text margin={0} fontSize={'1rem'} fontFamily={'Lato'}>Select an appropriate subject.</Text>
                  } aria-label='Default'>
                    <Text m={1} color={"#333"} fontSize={pxToRem(18)}>
                      {t('default')}
                    </Text>
                  </Tooltip>
                  </Button>
                  <Button
                    w={"full"}
                    mt={2}
                    border={'1px solid #3898FF44'}
                    bgColor={"transparent"}
                    cursor={'pointer'}
                    _hover={{ color: "#ADD2FC", bg: '#3898FF33' }}
                    onClick={() =>{
                      setStructureType('refer')
                      setFocusEditor(false)
                      openStructure()
                    }}
                  >
                    <Tooltip hasArrow placement={'right'}
                             borderRadius={pxToRem(6)}
                             padding={4} bg={'#FFF'} color={'#333'} label={
                      <Text fontSize={'1rem'} fontFamily={'Lato'}>Upload a PDF article for Doneba to extract its outline automatically.</Text>
                    } aria-label='Extract'>
                      <Text m={1} color={"#333"} fontSize={pxToRem(18)}>
                        {t('extract')}
                      </Text></Tooltip>
                  </Button>
                </Flex>
              </Box>
            )}
           
           <Button
                    w={"full"}
                    mt={2}
                    border={'1px solid #3898FF44'}
                    bgColor={"transparent"}
                    cursor={'pointer'}
                    _hover={{ color: "#ADD2FC", bg: '#3898FF33' }}
                    onClick={() =>{
                      setStructureType('refer')
                      setFocusEditor(false)
                      openStructure()
                    }}
                  >
                    <Tooltip hasArrow placement={'right'}
                             borderRadius={pxToRem(6)}
                             padding={4} bg={'#FFF'} color={'#333'} label={
                      <Text m={0} fontSize={'1rem'} fontFamily={'Lato'}>Upload a PDF article for Doneba to extract its outline automatically.</Text>
                    } aria-label='Extract'>
                      <Text m={1} color={"#333"} fontSize={pxToRem(18)}>
                        {t('extract')}
                      </Text></Tooltip>
                  </Button>

                <Box
            w={'120%'}
            h={"1.5px"}
            bgColor={"#D3D7E2"}
            mt={'20px'}
            mb={'8px'}
          />
          </Flex>
      
          <Box
            mt={5}
            h={`calc(100vh - ${
              referencePanelOpenStatus ? pxToRem(550) : pxToRem(520)
            })`}
          >
            {/** outline structure */}
            {outline && (
              <Box
                onClick={(e) => {
                  e.stopPropagation()
                  setFocusEditor(false)
                }}
                transition={'all .5s'}
                height={`calc(100vh - ${
                  referencePanelOpenStatus ? pxToRem(550) : pxToRem(520)
                })`}>
                <NodeTree setIsExport={setIsExport} updateOutlineStructure={updateOutlineStructure} />
              </Box>
            )}
          </Box>
         <Box position={'absolute'} left={0} bottom={'1.25rem'} w='100%'>
            <VStack justifyContent={'center'}>
              <Menu placement="right-start">
                  <MenuButton
                    as={Button}
                    mt={3}
                    px={0}
                    w={pxToRem(192)}
                    fontSize={pxToRem(18)}
                  >
                    <Box as="div" display={'flex'} justifyContent={'center'}>
                       <Image
                        w={pxToRem(20)}
                        objectFit="cover"
                        src="/static/editor/Export2.png"
                        alt="no draft"
                        mr={2}
                      />
                      {t("editor-editormodel-leftExport")}
                    </Box>
                  </MenuButton>
                <Portal>
                  <MenuList 
                    zIndex={1500}
                    border={"1px solid #cccccc"}
                    p={1}
                  >
                    <MenuItem 
                      as={Button}
                      _hover={{ bgColor: "#3898FF61" }}
                      borderRadius={10}
                      justifyContent="flex-start"
                      textAlign="left"
                      pl={0.5}
                      leftIcon={<Image src="/static/doenba-ico.png" w="20px" h="20px" />}
                      fontSize={14}
                      textColor={"black"}
                      bg="transparent"
                      fontWeight="normal"
                      onClick={onDoenbaExportOpen}
                    >
                      Save as .edi File 
                      <Tooltip  placement={'right'}
                            borderRadius={pxToRem(6)}
                            padding={4} label={
                        <Text margin={0} fontSize={'1rem'} fontFamily={'Lato'}>An .edi file lets you export content from one Doenba Edit account and import it into another.</Text>
                      } aria-label='.edi File'>
                        <Image src="/static/editor/question.svg" w="16px" h="16px" ml="4px" />
                      </Tooltip>
                    </MenuItem>
                  <MenuItem 
                    as={Button}
                    _hover={{ bgColor: "#3898FF61" }}
                    borderRadius={10}
                    justifyContent="flex-start"
                    textAlign="left"
                    pl={0.5}
                    leftIcon={<Image src="/static/editor/style-template.png" w="20px" h="20px" />}
                    fontSize={14}
                    textColor={"black"}
                    bg="transparent"
                    fontWeight="normal"
                    onClick={() => setIsExport(true)}
                  >
                    Export with Template
                    <Tooltip  placement={'right'}
                          borderRadius={pxToRem(6)}
                          padding={4} label={
                      <Text margin={0} fontSize={'1rem'} fontFamily={'Lato'}>Export your paper in the selected template’s format—PDF and LaTeX included.</Text>
                    } aria-label='Template Export'>
                      <Image src="/static/editor/question.svg" w="16px" h="16px" ml="4px" />
                    </Tooltip>
                  </MenuItem>
                </MenuList>
                </Portal>
              </Menu>
          </VStack>
          <Center mt={7}>
            <ChakraLink
                        color={'#333333'}
                        fontFamily={'Lato'}
                        _hover={{ textDecoration: 'none' }}
                        onClick={() => setDrawerOpenStatus(true)}
                        fontWeight={'bold'} fontSize={pxToRem(16)}>
              {t("editor-editormodel-leftTutorial")}
            </ChakraLink>
          </Center>
          <Center mt={4}>
            <ChakraLink
                        color={'#333333'}
                        fontFamily={'Lato'}
                        _hover={{ textDecoration: 'none' }}
                        onClick={() => navigate('/support')}
                        fontWeight={'bold'} fontSize={pxToRem(16)}>
              Support
            </ChakraLink>
          </Center>
           
         </Box>
        </Flex>
        {/** create outline by doenba */}
        {isStructureOpen && <DoenbaStructure isOpenModal={isStructureOpen} onModalClose={closeStructure}
                                             updateOutlineStructure={updateOutlineStructure}
                                             setPopOpen={setPopOpen}
                                             structureType={structureType} writingArea={writingArea} />}
      </Flex>
      {popOpen && <VStack ref={popupRef} zIndex={9999} w={pxToRem(200)} bg={'#FFF'} px={4} py={2} pt={5} border={'1px solid #ADD2FC'}
                          borderRadius={pxToRem(12)}
                          boxShadow={'0 0 2px #ADD2FC'}
                          opacity={popOpen ? 1 : 0}
                          transition={'all .5s'}
                          position={'fixed'} top={pxToRem(138)} left={'14.7%'}>
        {subject.map((item) => {
          return (
            <Text w={'full'} textAlign={'center'} py={1}
                  cursor={'pointer'}
                  key={item.label}
                  m={1} color={"#333"} fontSize={pxToRem(18)}
                  _hover={{ bg: '#3898FF33' }}
                  border={'1px solid #ADD2FC'} borderRadius={pxToRem(6)}
                  onClick={() => {
                    setWritingArea(item.value)
                    setFocusEditor(false)
                    openStructure()
                    setPopOpen(false)
                  }}>
              {item.label}
            </Text>
          )
        })}
      </VStack>}
     
      <DoenbaExportModal isOpen={isDoenbaExportOpen} onClose={onDoenbaExportClose} paperTitle={paperName} paperId={paperId} />
    </React.Fragment>
  )
}